export const STATUS_LABEL = "Status";
export const TIPO_LABEL = "Tipo";
